import { render, staticRenderFns } from "./QuestionnaireInquiry.vue?vue&type=template&id=2d18676c&scoped=true&"
import script from "./QuestionnaireInquiry.vue?vue&type=script&setup=true&lang=js&"
export * from "./QuestionnaireInquiry.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./QuestionnaireInquiry.vue?vue&type=style&index=0&id=2d18676c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d18676c",
  null
  
)

export default component.exports